<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="イントラネットFW契約変更"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- イントラネットFW契約 -->
      <cross-validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form
          novalidate
          @submit.stop.prevent="handleSubmit(showIntranetFwConfirm)"
        >
          <v-card-text class="px-0">
            <div class="modal-body">
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  イントラネットFW契約
                </v-card-title>
                <v-card-text>
                  <cross-validation-provider
                    :passed="moreThenValue"
                    vid="noExtraZone"
                    class="mb-2"
                  >
                    アクセス回線、リモートアクセスゲートウェイ、プラットフォームゲートウェイの分配ポリシー合計値がイントラネットFW契約帯域を超えています。
                  </cross-validation-provider>
                  <v-radio-group
                    v-model="intranetFwContractFlag"
                    inline
                    hide-details
                  >
                    <div class="d-flex align-center">
                      <v-radio :value="true" label="ON" />
                      <!-- イントラネットFW 帯域値-->
                      <app-select
                        class="ml-2 w-120"
                        v-model="intranetFwContract.intranetFwBandwidth"
                        :items="speedOptions"
                        item-title="text"
                        item-value="value"
                        :disabled="!intranetFwContractFlag"
                        hide-details
                      />
                      <div class="ml-1">Mbps</div>
                      <v-radio class="ml-4" :value="false" label="OFF" />
                    </div>
                  </v-radio-group>
                </v-card-text>
              </v-card>

              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  <app-badge
                    item="分配ポリシー"
                    :is-required="false"
                    msg="割当帯域を0.1Mbps刻みで指定可能。
                  チェックボックスからチェックを外した回線はイントラネットFWは適用除外されます。
                  また、イントラネットFWの再適用はできません。"
                    placement="end"
                  />
                </v-card-title>
                <v-card-text>
                  <!-- サブタイトル：アクセス回線 -->
                  <template
                    v-if="intranetFwContractItem.accessLineList.length > 0"
                  >
                    <div class="text-h7 font-weight-bold">アクセス回線</div>
                    <v-row justify="space-between">
                      <v-col
                        cols="4"
                        v-for="(
                          item, index
                        ) in intranetFwContract.accessLineList"
                        :key="index"
                      >
                        <v-checkbox
                          density="compact"
                          v-model="item.isCheck"
                          :label="item.enumber"
                          hide-details
                        />
                        <validation-provider
                          :name="`lineNumbers_${index}`"
                          :model-value="item.bandwidth.value"
                          label="割当帯域"
                          :rules="
                            item.isCheck
                              ? {
                                  required: true,
                                  between: {
                                    min: 0.1,
                                    max: intranetFwContract.intranetFwBandwidth
                                      .value,
                                  },
                                  double:
                                    item.bandwidth.value % 1 === 0
                                      ? false
                                      : { decimals: 1 },
                                }
                              : ''
                          "
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input-number
                            v-bind="{ name: componentField.name }"
                            v-model.number="item.bandwidth.value"
                            :decimal="true"
                            max-width="215px"
                            step="0.1"
                            min="0.1"
                            :max="intranetFwContract.intranetFwBandwidth.value"
                            :disabled="!item.isCheck"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          >
                            <template #append>
                              <div>Mbps</div>
                            </template>
                          </app-form-input-number>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- サブタイトル：リモートアクセスゲートウェイ -->
                  <template
                    v-if="intranetFwContractItem.remoteAccessGwList.length > 0"
                  >
                    <div class="text-h7 font-weight-bold mt-3">
                      リモートアクセスゲートウェイ
                    </div>
                    <v-table density="compact" class="tr-bordered">
                      <thead class="v-table-head">
                        <tr>
                          <th>メニュー</th>
                          <th>品目</th>
                          <th>E番号</th>
                          <th>Act/Sby</th>
                          <th>割当帯域</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(
                            remote, index
                          ) in intranetFwContract.remoteAccessGwList"
                          :key="index"
                        >
                          <tr>
                            <td rowspan="2">
                              <v-checkbox
                                v-model="remote.isCheck"
                                :label="
                                  $filter.enumTo(remote.menu, 'remoteAccessGw')
                                "
                                hide-details
                              />
                            </td>

                            <td rowspan="2">
                              <span
                                v-if="remote.contractType === 'BESTEFFORT'"
                                >{{ "-" }}</span
                              >
                              <span v-else
                                >{{ remote.contractBandwidth!.value }}Mbps
                              </span>
                            </td>
                            <td>{{ remote.enumberAct }}</td>
                            <td>Act</td>
                            <td rowspan="2">
                              <div class="mt-4">
                                <validation-provider
                                  :name="`remoteGateway_${index}`"
                                  :model-value="remote.bandwidthActSby.value"
                                  label="割当帯域"
                                  :rules="
                                    remote.isCheck
                                      ? {
                                          required: true,
                                          between: {
                                            min: 0.1,
                                            max: intranetFwContract
                                              .intranetFwBandwidth.value,
                                          },
                                          double:
                                            remote.bandwidthActSby.value % 1 ===
                                            0
                                              ? false
                                              : { decimals: 1 },
                                        }
                                      : ''
                                  "
                                  v-slot="{
                                    componentField,
                                    errorMessage,
                                    meta,
                                  }"
                                >
                                  <app-form-input-number
                                    v-bind="{ name: componentField.name }"
                                    v-model.number="
                                      remote.bandwidthActSby.value
                                    "
                                    :decimal="true"
                                    :disabled="!remote.isCheck"
                                    step="0.1"
                                    min="0.1"
                                    :max="
                                      intranetFwContract.intranetFwBandwidth
                                        .value
                                    "
                                    :error-messages="errorMessage"
                                    :field-meta="meta"
                                  >
                                    <template #append>
                                      <div>Mbps</div>
                                    </template>
                                  </app-form-input-number>
                                </validation-provider>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="no-border-top">
                              {{ remote.enumberSby }}
                            </td>
                            <td class="no-border-top">Sby</td>
                          </tr>
                        </template>
                      </tbody>
                    </v-table>
                  </template>
                  <!-- サブタイトル：プラットフォームゲートウェイ -->
                  <template v-if="intranetFwContractItem.pfgwList.length > 0">
                    <div class="text-h7 font-weight-bold mt-3">
                      プラットフォームゲートウェイ
                    </div>
                    <v-table density="compact" class="tr-bordered">
                      <thead class="v-table-head">
                        <tr>
                          <th>エリア</th>
                          <th>E番号</th>
                          <th>Act/Sby</th>
                          <th>割当帯域</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(plat, index) in intranetFwContract.pfgwList"
                          :key="index"
                        >
                          <tr>
                            <td rowspan="2">
                              <v-checkbox
                                v-model="plat.isCheck"
                                hide-details
                                :label="plat.office"
                              />
                            </td>
                            <td>{{ plat.enumberAct }}</td>
                            <td>Act</td>
                            <td>
                              <div class="mt-2">
                                <validation-provider
                                  :name="`platFormGateway_${index}`"
                                  :model-value="plat.bandwidthActSby.value"
                                  label="割当帯域"
                                  :rules="
                                    plat.isCheck
                                      ? {
                                          required: true,
                                          between: {
                                            min: 0.1,
                                            max: intranetFwContract
                                              .intranetFwBandwidth.value,
                                          },
                                          double:
                                            plat.bandwidthActSby.value % 1 === 0
                                              ? false
                                              : { decimals: 1 },
                                        }
                                      : ''
                                  "
                                  v-slot="{
                                    componentField,
                                    errorMessage,
                                    meta,
                                  }"
                                >
                                  <app-form-input-number
                                    v-bind="{ name: componentField.name }"
                                    v-model.number="plat.bandwidthActSby.value"
                                    :decimal="true"
                                    :disabled="!plat.isCheck"
                                    step="0.1"
                                    min="0.1"
                                    :max="
                                      intranetFwContract.intranetFwBandwidth
                                        .value
                                    "
                                    :error-messages="errorMessage"
                                    :field-meta="meta"
                                    :hide-details="!errorMessage"
                                  >
                                    <template #append>
                                      <div>Mbps</div>
                                    </template>
                                  </app-form-input-number>
                                </validation-provider>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="no-border-top">{{ plat.enumberSby }}</td>
                            <td class="no-border-top">Sby</td>
                            <td class="no-border-top">
                              {{ plat.bandwidthActSby.value }}&ensp;Mbps
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </v-table>
                  </template>
                </v-card-text>
              </v-card>
            </div>
            <!-- 関連項目チェック: 初期表示した内容から設定内容に変更があること。-->
            <cross-validation-provider
              :passed="objectChanged"
              vid="no_change"
              class="mt-4"
            >
              {{ $filter.message("no_change_data") }}
            </cross-validation-provider>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">変更</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type {
  AccessLine,
  IntranetfwServiceMenu,
  IntranetfwServiceMenuDelete,
  IntranetfwServiceMenuPost,
} from "@/apis/IntranetfwServiceMenuApi";
import cloneDeep from "lodash/cloneDeep";
import AppSelect from "@/components/AppSelect.vue";
import AppFormInputNumber from "@/components/AppFormInputNumber.vue";
import { VueFinalModal } from "vue-final-modal";
import IntranetFwContractConfirm from "@/modals/applianceContractSetting/IntranetFirewall/contract/IntranetFwContractConfirm.vue";

export default defineComponent({
  name: "IntranetFwContractModify",
  components: { AppFormInputNumber, AppSelect },
  props: {
    intranetFwContractItem: {
      type: Object as PropType<IntranetfwServiceMenu>,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false as boolean,
      /** イントラネットFW契約変更表示用 */
      intranetFwContract: {} as IntranetfwServiceMenu,
      /** イントラネットFW契約変更ON/OFFフラグ */
      intranetFwContractFlag: true as boolean,
      /** イントラネットFW契約変更表示用reqData */
      postItem: {} as IntranetfwServiceMenuPost,
      /** イントラネットFW契約帯域用オプション */
      speedOptions: [
        ...[
          ...Array.range(10, 101, 10),
          ...Array.range(200, 1001, 100),
          ...Array.range(1500, 10001, 500),
        ].map((e) => ({
          value: { value: e, unit: "MBPS" },
          text: e.toString(),
        })),
      ],
    };
  },
  computed: {
    /** 関連項目チェック:帯域の合計値は契約帯域を超えないこと */
    moreThenValue(): boolean {
      let isNumber = 0;
      for (const num of this.intranetFwContract.accessLineList) {
        if (num.isCheck) {
          isNumber = this.totalValue(isNumber, num.bandwidth.value);
        }
      }
      for (const num of this.intranetFwContract.remoteAccessGwList) {
        if (num.isCheck) {
          isNumber = this.totalValue(isNumber, num.bandwidthActSby.value);
        }
      }
      for (const num of this.intranetFwContract.pfgwList) {
        if (num.isCheck) {
          isNumber = this.totalValue(isNumber, num.bandwidthActSby.value);
        }
      }
      // OFFのラジオを選択した場合
      if (!this.intranetFwContractFlag) {
        return isNumber === 0;
      }
      return isNumber <= this.intranetFwContract.intranetFwBandwidth.value;
    },
    /** 関連項目チェック:初期表示した内容から設定内容に変更があること */
    objectChanged(): boolean {
      if (!this.intranetFwContractFlag) return true;
      return this.$crossValidation.objectChanged(
        this.intranetFwContractItem,
        this.intranetFwContract
      );
    },
  },

  mounted() {
    this.intranetFwContract = cloneDeep(this.intranetFwContractItem);
    this.isLoaded = true;
  },
  methods: {
    /** イントラネットFW契約変更確認モーダルを表示 */
    async showIntranetFwConfirm() {
      await this.$modal.show(IntranetFwContractConfirm, {
        intranetFwContract: this.intranetFwContract,
        intranetFwContractFlag: this.intranetFwContractFlag,
        postItem: this.postItem,
      });
      if (this.intranetFwContractFlag) {
        // イントラネットFWの契約変更
        /**
         * 変更データの設定
         * MbpsからKbps,Mbpsへ変換
         * 削除部分の脱ぎ出し
         */
        this.postItem.contractIntranetFwKeyId =
          this.intranetFwContract.contractIntranetFwKeyId;
        this.postItem.intranetFwBandwidth = this.mbpsToBandwidth(
          this.intranetFwContract.intranetFwBandwidth.value
        );
        this.postItem.accessLineList = this.intranetFwContract.accessLineList
          .filter((item) => {
            return item.isCheck;
          })
          .map((e) => ({
            bandwidth: this.mbpsToBandwidth(e.bandwidth.value),
            enumber: e.enumber,
          }));
        this.postItem.remoteAccessGwList =
          this.intranetFwContract.remoteAccessGwList
            .filter((item) => {
              return item.isCheck;
            })
            .map((e) => ({
              bandwidthActSby: this.mbpsToBandwidth(e.bandwidthActSby.value),
              enumberAct: e.enumberAct,
            }));
        this.postItem.pfgwList = this.intranetFwContract.pfgwList
          .filter((item) => {
            return item.isCheck;
          })
          .map((e) => ({
            bandwidthActSby: this.mbpsToBandwidth(e.bandwidthActSby.value),
            enumberAct: e.enumberAct,
          }));
        this.postItem.note = this.postItem.note || null;

        await this.$api.intranetfwServiceMenu.postIntranetfwServiceMenu(
          this.postItem
        );
      } else {
        /** イントラネットFWの契約削除 */
        // 削除データの設定
        const reqData: IntranetfwServiceMenuDelete = {
          contractIntranetFwKeyId:
            this.intranetFwContract.contractIntranetFwKeyId,
          note: this.postItem.note || null,
        };
        await this.$api.intranetfwServiceMenu.deleteIntranetfwServiceMenu(
          reqData
        );
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * イントラネットFW割当帯域変更用MbpsからKbps、Mbpsへ
     */
    mbpsToBandwidth(item: number): AccessLine["bandwidth"] {
      if (item % 1 === 0) {
        return { value: item, unit: "MBPS" };
      } else {
        return { value: item * 1000, unit: "KBPS" };
      }
    },
    /**
     * 帯域値の合計算用、小数後一位まで
     */
    totalValue(valA: number, valB: number): number {
      return Math.round((valA + valB) * 10) / 10;
    },
  },
});
</script>

<style lang="scss" scoped>
.w-120 {
  width: 120px;
}
:deep(.v-card.v-card--variant-outlined) {
  border-color: rgba(0, 0, 0, 0.125) !important;
}
:deep(.v-card-title .v-label.badge-label) {
  font-size: 1.5rem;
}
:deep(.v-input--horizontal .v-input__append) {
  margin-inline-start: 4px;
}
.no-border-top {
  border-top: 0 !important;
}
</style>
